type MicroFrontendConfigs = typeof window.__app_config.WEBUI_MICROFRONTENDS;

type MfeConfig = {
  microFrontendConfigs: MicroFrontendConfigs;
};

export const MFE_CONFIG: MfeConfig = {
  microFrontendConfigs: window.__app_config.WEBUI_MICROFRONTENDS,
};
